import isEmpty from 'lodash/isEmpty';
import reduce from 'lodash/reduce';
import difference from 'lodash/difference';
import find from 'lodash/find';
import findLastIndex from 'lodash/findLastIndex';
import { validateEmail as validateEmailUtil } from '@Utils/Email';
import {
  ALERT_NAME_MIN_LENGTH,
  ALERT_NAME_MAX_LENGTH,
  getAlertNameMinLengthValidationMessage,
  getAlertNameMaxLengthValidationMessage,
  emailValidationMessage,
  emptyInputValidationMessage,
  emptyDatabasesValidationMessage,
  incompatibleDatabasesValidationMessage,
  getDuplicateAlertNameValidationMessage,
} from './AlertCreateDialogConstatns';

export function validateEmptyInput(input) {
  const isValid = !isEmpty(input);

  return {
    isValid,
    ...(!isValid && {
      validationMessage: emptyInputValidationMessage,
      preventChange: false,
    }),
  };
}

export function validateDuplicateAlertName(alertName, alerts, originalAlertName) {
  const isValid = reduce(
    alerts,
    (memo, dbAlerts) => memo && !(dbAlerts || []).filter((a) => a !== originalAlertName).includes(alertName),
    true
  );

  return {
    isValid,
    ...(!isValid && {
      validationMessage: getDuplicateAlertNameValidationMessage(alertName),
      preventChange: false,
    }),
  };
}

export function validateAlertNameLength(alertName = '') {
  const value = alertName ?? '';

  if (!isEmpty(value) && value.length < ALERT_NAME_MIN_LENGTH) {
    return {
      isValid: false,
      validationMessage: getAlertNameMinLengthValidationMessage(),
      preventChange: false,
    };
  }

  if (value.length > ALERT_NAME_MAX_LENGTH) {
    return {
      isValid: false,
      validationMessage: getAlertNameMaxLengthValidationMessage(),
      preventChange: false,
    };
  }

  return { isValid: true };
}

export function validateEmptyEmails(emails) {
  const isValid = !isEmpty(emails);

  return {
    isValid,
    ...(!isValid && {
      validationMessage: emptyInputValidationMessage,
    }),
  };
}

export function validateEmail(email) {
  const isValid = validateEmailUtil(email);

  return {
    isValid,
    ...(!isValid && {
      validationMessage: emailValidationMessage,
    }),
  };
}

export function validateEmptyDatabases(databases) {
  const isValid = !isEmpty(databases);

  return {
    isValid,
    ...(!isValid && {
      validationMessage: emptyDatabasesValidationMessage,
    }),
  };
}

export function validateDatabases(alertFormDatabases, originalDatabases, alertsInfoDatabases) {
  const isValid = !isEmpty(alertFormDatabases);
  const isCompatible = isEmpty(difference(originalDatabases, alertsInfoDatabases));

  return {
    isValid,
    ...(!isValid && {
      validationMessage: isCompatible ? emptyDatabasesValidationMessage : incompatibleDatabasesValidationMessage,
    }),
  };
}

export function combineValidators(...validators) {
  return ({ combineLogic = '&&' } = {}) => {
    const firstInvalid = find(validators, (v) => v && !v.isValid);
    const lastValid = validators?.[findLastIndex(validators, (v) => v?.isValid)];

    switch (combineLogic) {
      case '&&': {
        return firstInvalid || lastValid;
      }
      case '||': {
        return lastValid || firstInvalid;
      }
      default: {
        Logger.error('Invalid combineLogic');
      }
    }
  };
}
